export var ForwardModalTab;
(function (ForwardModalTab) {
    ForwardModalTab["DestinationsList"] = "DestinationsList";
    ForwardModalTab["Actions"] = "Actions";
})(ForwardModalTab || (ForwardModalTab = {}));
